// ChatCommitContext — bridges the editor's commit capabilities into the chat's
// tool-UIs.
//
// assistant-ui's makeAssistantToolUI components are registered globally inside
// the <AssistantRuntimeProvider> and render without props, so a tool-UI can't be
// handed the editor's `addImageToScene` directly. ChatPanel builds that function
// from its `widgetProps` and provides it here; the tool-UI reads it via the
// `useChatCommit()` hook for its Accept handler.
//
// Default value is an empty object so a tool-UI rendered outside a provider (e.g.
// in isolation) degrades gracefully — `addImageToScene` is simply undefined and
// the card's Accept handler can show a "Couldn't add" state instead of throwing.

import { createContext, useContext } from "react";

// Value shape: { addImageToScene?: (imageUrl: string) => Promise<void> }
export const ChatCommitContext = createContext({});

// Read the chat commit capabilities provided by ChatPanel.
export function useChatCommit() {
  return useContext(ChatCommitContext);
}

export default ChatCommitContext;
